import { FC, useCallback } from 'react';

import { useSelector } from 'react-redux';

import { useParams, useNavigate } from 'react-router-dom';

import liff from '@line/liff';

import { useGetProgressData } from 'hooks/useGetProgressData';
import { usePageTitle } from 'hooks/usePageTitle';

import { Button } from 'components/parts/Button';
import { Particle } from 'components/parts/Particle';
import { Sparcles } from 'components/parts/Sparcles';
import { RootState } from 'store';
import { useGetProgressQuery } from 'store/progress';
import { usePostRewardDataMutation } from 'store/reward';

import styles from './Reward.module.scss';

export const Reward: FC = () => {
  const navigate = useNavigate();
  const { id: idParam } = useParams<{ id?: string }>();
  const id =
    idParam === 'halfway'
      ? 'halfway'
      : idParam === 'almost'
      ? 'almost'
      : idParam === 'perfect'
      ? 'perfect'
      : 'halfway';
  // microCMSから取得した記念品データ
  const { reward } = useSelector((state: RootState) => state.external);
  const [postRewardData, { isLoading }] = usePostRewardDataMutation();
  const { data: progressData } = useGetProgressData();
  const { refetch: refetchProgress } = useGetProgressQuery();
  // 現在表示中ページの記念品データ
  const matchedReward = reward.find(item => item.rewardId === id);
  // 二次元コードの値
  const rewardScanCode = matchedReward?.rewardScanCode;

  usePageTitle(
    id === 'halfway'
      ? '5エリアクリア'
      : id === 'almost'
      ? '10エリアクリア'
      : id === 'perfect'
      ? 'パーフェクト賞'
      : '賞品受け取り'
  );

  const handleScanQrCode = useCallback(async () => {
    try {
      // QRコードをスキャンする
      const scanResult = await liff.scanCodeV2();
      const { value } = scanResult;

      // スキャン結果が期待する二次元コード情報と一致する場合
      if (value === rewardScanCode) {
        // データをPOSTする
        await postRewardData({ id: id as 'halfway' | 'almost' | 'perfect' });
        // 進行状況を再取得して状態を更新する
        await refetchProgress();
        console.log({ progressData });
        // 成功ページにリダイレクトする
        navigate(`/reward/success/${id}`);
      } else {
        // 失敗ページにリダイレクトする
        navigate(`/reward/failure/${id}`);
      }
    } catch (error) {
      console.error(error);
    }
  }, [id, rewardScanCode, postRewardData, refetchProgress, navigate, progressData]);

  const rewardReceived = id ? progressData?.rewardList.includes(id) : false;

  const handleGoHome = () => {
    navigate('/home');
  };

  return (
    <>
      <div className={styles.wrapper}>
        <Particle />
        <div className={styles.inner}>
          <div className={styles.header}>
            <div className={styles.headerHead}>
              <h1 className={styles.headerTitle}>
                <div className={styles.headerTitleHead}>
                  <span className={styles.headerTitleCount}>
                    {id === 'halfway' && '5'}
                    {id === 'almost' && '10'}
                    {id === 'perfect' && '全'}
                  </span>
                  <span className={styles.headerTitleText}>エリア</span>
                </div>
                <div className={styles.headerTitleBody}>
                  <img
                    src={require('images/reward/clear.webp')}
                    alt="CLEAR"
                    className={styles.headerClear}
                  />
                  <Sparcles />
                </div>
              </h1>
            </div>
          </div>
          <div className={styles.body}>
            <div className={styles.text}>
              {id === 'halfway' && (
                <p>
                  近くの報告所に行くと、5エリアクリア賞を受け取れるよ！報告所の二次元コードを読み取って記念品をもらおう。
                </p>
              )}
              {id === 'almost' && (
                <p>
                  近くの報告所に行くと、10エリアクリア賞を受け取れるよ！報告所の二次元コードを読み取って記念品をもらおう。
                </p>
              )}
              {id === 'perfect' && (
                <p>
                  近くの報告所に行くと、パーフェクト賞を受け取れるよ！報告所の二次元コードを読み取って記念品をもらおう。
                </p>
              )}
            </div>
            {/* TODO: 画像を入れ替える */}
            <div className={styles.rewardImage}>
              {id === 'halfway' && (
                <img
                  src={require(`images/reward/halfway.webp`)}
                  alt="コードF15 ODYSSEY オリジナルクリアファイル"
                />
              )}
              {id === 'almost' && (
                <img
                  src={require(`images/reward/almost.webp`)}
                  alt="コードF15 ODYSSEY オリジナルノート"
                />
              )}
              {id === 'perfect' && (
                <img
                  src={require(`images/reward/perfect.webp`)}
                  alt="コードF15 ODYSSEY オリジナルメダル"
                />
              )}
              <img
                src={require(`images/character/chara-kirakira-top.webp`)}
                alt=""
                className={styles.chara}
              />
            </div>
          </div>
          <div className={styles.foot}>
            <div className={styles.action}>
              {rewardReceived ? (
                <Button text="受け取り済みです" styleType="primary" disabled={true} />
              ) : (
                <Button
                  text="二次元コードを読み取る"
                  styleType="primary"
                  handleClick={handleScanQrCode}
                  disabled={isLoading}
                />
              )}
            </div>
            <div className={styles.back}>
              {rewardReceived ? (
                <Button text="ホームに戻る" styleType="ghost" handleClick={handleGoHome} />
              ) : (
                <Button text="あとで受け取る" styleType="ghost" handleClick={handleGoHome} />
              )}
            </div>
            {/* <Button
              text="送信済みにする"
              styleType="ghost"
              handleClick={handleClick}
              disabled={isLoading}
            /> */}
          </div>
        </div>
      </div>
    </>
  );
};
